import { Controller } from "@hotwired/stimulus"

// Displays the character count for a Lexxy rich text editor
// Usage: Wrap the rich_textarea with data-controller="text-length"
//        Add a target element with data-text-length-target="counter"
export default class extends Controller {
  static targets = ["counter"]

  connect() {
    this.editor = this.element.querySelector("lexxy-editor")
    if (this.editor) {
      this.boundUpdateCount = this.updateCount.bind(this)
      this.editor.addEventListener("lexxy:initialize", this.boundUpdateCount)
      this.editor.addEventListener("lexxy:change", this.boundUpdateCount)

      if (this.editor.editorContentElement) {
        this.updateCount()
      }
    }
  }

  disconnect() {
    if (this.editor && this.boundUpdateCount) {
      this.editor.removeEventListener("lexxy:initialize", this.boundUpdateCount)
      this.editor.removeEventListener("lexxy:change", this.boundUpdateCount)
    }
  }

  updateCount() {
    if (this.hasCounterTarget && this.editor?.editorContentElement) {
      const text = this.editor.editorContentElement.textContent || ""
      this.counterTarget.textContent = text.length.toLocaleString()
    }
  }
}
